<template>
  <div class="address">
    <div class="head">
      <h3>收货信息</h3>
    </div>
    <div class="info" @click="getAddressId">
      <div class="top">
        <div class="name">{{ addressInfo.name }}</div>
        <div class="phone">{{ addressInfo.tel }}</div>
      </div>
      <div class="area">
        <span>配置至:</span> {{ addressInfo.provinceName }}
        {{ addressInfo.cityName }} {{ addressInfo.countyName }}
        {{ addressInfo.townName }}
      </div>
      <div class="ad-detail">{{ addressInfo.address }}</div>
    </div>
  </div>
</template>
<script>
// import { getDefaultAddress, getAddressInfo } from '@/api/address'
import { adType } from '@/utils/Address'
export default {
  props: {
    addressInfo: {
      type: Object
    }
  },
  methods: {
    getAddressId () {
      this.$router.push({
        path: `myaddress#${adType['payment']}`,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.address {
  font-size: 0.32rem;
  .head {
    padding-left: 0.2rem;
  }
  .info {
    padding: 0.3rem 0.2rem;
    width: 6.7rem;
    border-radius: 10px;
    margin: auto;
    background: url('../../../assets/icon/paymennt.png') 9px bottom no-repeat;
    background-size: 7rem;
    background-color: white;
    .top {
      @include flexBox(space-between);
      font-weight: 800;
      margin: 0.1rem 0;
    }
  }
  .area {
    font-size: 0.28rem;
    font-weight: 800;
    span {
      padding-right: 0.2rem;
    }
  }
}
</style>